import {getScope} from "./state";
import {handleCheckoutErrors} from './checkout-errors';
import {messageParent} from './messaging';

const init = () => {
    const scope = getScope();
    handleCheckoutErrors();
    scope.$apply();
};

let built = false;

/**
 * moves the content fields into a config property on the scope for the custom-event
 * @param {Object} options - content fields
 */
const commonBuildSteps = (options) => {
    const scope = getScope();
    Object.assign(scope, options);
    scope.config = options;
    scope.$apply();
    scope.affiliate = scope.custom.origin;
};

/*
 * merge options and message main window
 * {Object} options - options to merge into scope
 */
const build = (options = {}) => {
    commonBuildSteps(options);
};

/*
* called from the checkout template to set selectedTerm and merge variables
* {Object} options - params to merge
*/
const buildSystem = (options = {}) => {
    commonBuildSteps(options);
};

/*
 * pass in an init method to load when piano loads
 * {Function} initMethod - method to init with after load
 */
const start = (initMethod) => {
    getScope().$on('loaded', () => {
        !built && initMethod();
        built = true;
    });
    try {
        !built && initMethod(); // if the load event has run before piano processed our script directive
        built = true;
    } catch (e) {
        built = false;
    }
};

window.Advance = {
    piano: {
        start,
        build,
        buildSystem,
        messageParent,
    },
};

init();